"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PolicyIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="151676" id="overview" className="bg-background py-40 px-6 md:px-12 lg:px-24 flex flex-col items-center justify-center text-center">
      <div ref={ref} className={`max-w-3xl mx-auto flex flex-col items-center transition-all duration-1000 ease-out hover:shadow-2xl hover:bg-white/50 rounded-xl p-8 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <span className="font-mono font-medium text-accent-foreground uppercase tracking-widest text-sm mb-6 block">
          Precision Methodology
        </span>
        
        <h1 className="font-sans text-primary text-5xl md:text-6xl lg:text-7xl tracking-tighter mb-8 leading-tight font-bold">
          Step-by-Step Precision
        </h1>
        
        <p className="font-sans font-semibold text-primary text-2xl leading-relaxed max-w-2xl">
          Our framework transforms complex requirements into actionable milestones, delivering Project Charters and Microsoft Project Plans with absolute strategic alignment.
        </p>
      </div>
    </section>;
}